import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconPackage from '@/icons/Package.svg';

export const ShipmentPreparationCompletedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'shipment_preparation_completed'>;
}) => {
  const creatorName = activity.creator?.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconPackage />}
      message={
        <BaseActivityText>
          {activity.creator ? (
            <Trans id="activities.shipment_preparation_completed.message">
              <strong>{creatorName}</strong> validated the package preparation
            </Trans>
          ) : (
            <Trans id="activities.shipment_preparation_completed.message.no-creator">
              The package preparation was validated
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
